// extracted by mini-css-extract-plugin
export default {"editor":"App_editor__7B75Q","doc":"App_doc__7iS0f","logo":"App_logo__Tb1Q+"};